import { AlertTriangle, CheckCircle } from "lucide-react";

import {
  isCorrectedResult,
  isSupersededResult,
} from "../../utils/resultCorrection";
import styles from "./ResultCorrectionNotice.module.css";

/*
 * At the top of a result's detail: this one replaced an earlier result, or has itself been
 * replaced (KIN-2089). Nothing is rendered for the ordinary result.
 *
 * `onOpenRelated` is offered only when the counterpart is on the page the reader already has.
 * Results page server-side, so a correction and the result it replaces are often on different
 * pages, and the backend has no by-inbox-id fetch — so the relationship is always stated, and the
 * link appears when we can honour it. A link that led nowhere would be worse than its absence.
 */
export const ResultCorrectionNotice = ({ result, onOpenRelated }) => {
  const superseded = isSupersededResult(result);
  const corrected = isCorrectedResult(result);

  if (!superseded && !corrected) return null;

  const Icon = superseded ? AlertTriangle : CheckCircle;

  return (
    <div
      className={`${styles.notice} ${
        superseded ? styles.superseded : styles.corrected
      }`}
      role={superseded ? "alert" : undefined}
    >
      <Icon size={16} className={styles.icon} />
      <p className={styles.text}>
        {superseded
          ? "The laboratory replaced this result with a correction. Do not act on the values below."
          : "This result is a correction the laboratory sent for an earlier result."}
        {!!onOpenRelated && (
          <button type="button" className={styles.link} onClick={onOpenRelated}>
            {superseded
              ? "Open the corrected result"
              : "Open the result it corrects"}
          </button>
        )}
      </p>
    </div>
  );
};
